// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fW","advertDetailService__price":"c-o_fX"};